<template>
  <v-container fluid class="pa-0 fill-height">
    <v-row class="fill-height">
      <v-col cols="12" md="2">
        <template v-if="loading">
          <div class="fill-height d-flex justify-center align-center">
            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
          </div>
        </template>
        <template v-else>
          <div :class="$vuetify.breakpoint.xs ? '' : 'split'">
            <div style="max-height: 100%; overflow-y: scroll">
              <v-treeview :items="treeMapItems" selectable v-model="selectedDevices"></v-treeview>
            </div>
          </div>
        </template>
      </v-col>
      <v-col cols="12" md="10" class="pa-0">
        <google-map v-slot="{ google, map }" class="fill-height" style="height: 100vh" ref="gmap">
          <google-map-control :google="google" :map="map">
              <v-btn color="primary" @click="fetchDevices">갱신</v-btn>
            </google-map-control>
          <template v-for="marker in positions">
            <google-map-marker :google="google" :map="map" :marker-options="marker" :key="marker._id"></google-map-marker>
          </template>
        </google-map>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getDeviceList } from '@/api'
import groupBy from 'lodash/groupBy'
import get from 'lodash/get'

export default {
  data () {
    return {
      devices: [],
      selectedDevices: [],
      loading: false,
      interval: null
    }
  },
  watch: {
    selectedDevices (devices) {
      if (!devices.length) return

      const positions = this.positions.map(device => {
        return device.position
      })

      this.$refs.gmap.fitBounds(positions)
    }
  },
  computed: {
    positions () {
      const map = this.devices.reduce((map, device) => {
        map[device._id] = device

        return map
      }, {})

      return this.selectedDevices.reduce((positions, _id) => {
        const device = map[_id]
        const plateNo = get(device, 'info.plateNo', '미등록')
        const pos = get(device, '_d.pos')

        if (!pos) return positions

        positions.push({
          _id: _id + new Date().valueOf(),
          plateNo,
          position: pos,
          labelContent: plateNo
        })

        return positions
      }, [])
    },
    groups () {
      return this.devices.reduce((groups, device) => {
        if (!device.group) {
          const _id = 'defaultGroup'
          const name = '미등록'

          if (!groups[_id]) groups[_id] = name

          return groups
        }
        const { _id, name } = device.group

        if (!groups[_id]) groups[_id] = name

        return groups
      }, {})
    },
    treeMapItems () {
      const groupByGroups = groupBy(this.devices, (device) => {
        if (!device.group) return null
        const { _id = null } = device.group

        return _id
      })

      const items = Object.entries(groupByGroups).map(([key, devices]) => {
        return {
          id: key,
          name: this.groups[key],
          children: devices.map((device) => {
            return {
              id: device._id,
              name: get(device, 'info.plateNo', '미등록')
            }
          })
        }
      })
        .sort((a, b) => {
          return a.name > b.name ? 1 : -1
        })

      return items
    }
  },
  async created () {
    await this.fetchDevices()
  },
  methods: {
    async fetchDevices () {
      this.loading = true
      try {
        const query = {
          fields: 'name company group info.plateNo _d.pos',
          populate: '_d'
        }

        const { devices } = await getDeviceList(null, query)

        this.devices = devices
      } catch (err) {
        console.error(err.message)
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
  .split {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0
  }
</style>
